import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

export const AutocompleteSelectTable = ({id, values, label,setValues, setFieldTouched, touched, error, helperText, sequenceNumber, ...props}) => {
    const content = props.colDef.content
    let getRows = JSON.parse(JSON.stringify(values));
    const field = props.field
    const onChange = (e, newValue) => {
        let newRows = []
        getRows.map(i => {
                if (i.id === props.row.id) {
                    let newRow = i
                    newRow[props.field] = newValue;
                    newRows.push(newRow)
                } else newRows.push(i)
            })
        setValues(newRows)
                if (!touched && setFieldTouched) {
            setFieldTouched(props.field, true, false)
        }
    }
    
    return <Autocomplete
    freeSolo
        fullWidth
        inputValue={values[props?.field]}
        value={values[props?.field]}
        clearOnEscape
        options={content.choices}
        getOptionLabel={(option) => option.value}
        getOptionSelected={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params}
                                            variant={'outlined'}
                                            size={"small"}
                                            fullWidth
                                            error={touched && Boolean(error)}
                                            helperText={error && touched ? error : helperText}
                                            label={label}/>}
        {...props}
        onChange={onChange}
    />
}